import React from 'react'
import injectSheet from 'react-jss'
import styles from './edit-dialog.styles'
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalContent
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import { Formik } from 'formik'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import FormRow from '../../../../components/common/form-elements/form-row/form-row'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import * as Yup from 'yup'

const TITLE_MAX_LENGTH = 45
const TEXT_MAX_LENGTH = 1000
const OPTIONS_MAX_LENGTH = 200

const ExerciseSlideEditDialog = ({
  classes,
  modalOpened,
  onChange,
  onClose,
  onSubmit,
  onDelete,
  title,
  text,
  options,
  updating,
  deleting
}) => (
  <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
    <ModalHeader>Update exercise slide</ModalHeader>
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        title: title || '',
        text: text || '',
        options: options || ''
      }}
      validationSchema={Yup.object().shape({
        title: Yup.string().required(
          'Please provide a title for your exercise'
        ),
        text: Yup.string().required(
          'Please provide some text for your exercise'
        ),
        options: Yup.string().required(
          'Please provide some prompts for your exercise'
        )
      })}>
      {({
        handleSubmit,
        handleBlur,
        handleChange,
        values,
        errors,
        touched
      }) => {
        return (
          <form onSubmit={handleSubmit} className="metrics__slide-form">
            <ModalContent legacy>
              <FormRow first>
                <FormLabel small spaceBetween htmlFor="exerciseSlideTitle">
                  <span>Title</span>
                  <CharactersCount
                    value={values.title}
                    max={TITLE_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  validationError={touched.title && errors.title}
                  placeholder="e.g. Exciting story"
                  className={classes.title}
                  id="exerciseSlideTitle"
                  name="title"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={TITLE_MAX_LENGTH}
                  autoFocus={true}
                />
              </FormRow>
              <FormRow>
                <FormLabel small spaceBetween htmlFor="exerciseSlidePrompts">
                  <span>Text</span>
                  <CharactersCount value={values.text} max={TEXT_MAX_LENGTH} />
                </FormLabel>
                <FormTextArea
                  validationError={touched.text && errors.text}
                  placeholder="e.g. It was ______ in the room"
                  id="exerciseSlidePrompts"
                  name="text"
                  value={values.text}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  textAreaProps={{ maxLength: TEXT_MAX_LENGTH }}
                />
              </FormRow>
              <FormRow>
                <FormLabel small spaceBetween htmlFor="exerciseSlideOptions">
                  <span>Word bank</span>
                  <CharactersCount
                    value={values.options}
                    max={OPTIONS_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  validationError={touched.options && errors.options}
                  placeholder="e.g. black, dark, blue"
                  id="exerciseSlideOptions"
                  name="options"
                  value={values.options}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={OPTIONS_MAX_LENGTH}
                />
              </FormRow>
            </ModalContent>
            <ModalFooter alignRight childrenGap>
              <Button action={onClose} tall simple>
                Cancel
              </Button>
              <Button tall type="submit" disabled={updating}>
                {!updating && 'Save'}
                {updating && 'Saving...'}
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(ExerciseSlideEditDialog)
